import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Tab from "../../common/Tab";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import PRSummary from "./Summary";
import CandidateList from "./CandidateList";
import AllParty from "./AllParty";
import NotFound from "../../common/ErrorPage/NotFound";

import { API_BASE_PATH, API_URL, ENV } from "../../../config";

import "./index.css";

const ProportionalResult = (props) => {
  const [result, setResult] = useState({});
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    // if already not fetched
    if (Object.keys(props.data).length === 0) {
      fetch(API_URL + "result/proportional" + (ENV === "LOCAL_CLIENT_ONLY" ? ".json" : ""))
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          const federalData = response.data.map((d) => ({ party: d.party, vote: d.vote })).sort((a, b) => b.vote - a.vote);
          const formattedData = { federal: [{ province: 0, data: federalData }], provincial: [] };
          props.provinces.forEach((p, i) => {
            const provinceData = { province: p.id, data: response.data.map((d) => ({ party: d.party, vote: d["vote_p" + (i + 1)] })) };
            provinceData.data = provinceData.data.sort((x, y) => y.vote - x.vote);
            formattedData.provincial.push(provinceData);
          });
          setFetched(true);
          setResult(formattedData);
        })
        .catch((e) => {
          console.error(e.toString());
          fetch(API_BASE_PATH + "result/proportional.json")
            .then((r) => {
              return r.json();
            })
            .then((response) => {
              const federalData = response.data.map((d) => ({ party: d.party, vote: d.vote })).sort((a, b) => b.vote - a.vote);
              const formattedData = { federal: [{ province: 0, data: federalData }], provincial: [] };
              props.provinces.forEach((p, i) => {
                const provinceData = { province: p.id, data: response.data.map((d) => ({ party: d.party, vote: d["vote_p" + (i + 1)] })) };
                provinceData.data = provinceData.data.sort((x, y) => y.vote - x.vote);
                formattedData.provincial.push(provinceData);
              });
              setFetched(true);
              setResult(formattedData);
            })
            .catch((e) => {
              setFetched(true);
              console.error(e);
            });
        });
    } else {
      setFetched(true);
      setResult(props.data);
    }
  }, [props.provinces, props.data]);

  return (
    <>
      <Tab tab={props.tab} handleTabChange={props.handleTabChange} />
      <BreadcrumbSearch showSearch={false} provinces={props.provinces} />
      <Routes>
        <Route path="/" element={<PRSummary fetched={fetched} tab={props.tab} provinces={props.provinces} parties={props.parties} result={result} />}></Route>
        <Route path="allparties" element={<AllParty fetched={fetched} tab={props.tab} provinces={props.provinces} parties={props.parties} result={result} />}></Route>
        <Route path=":type" element={<CandidateList tab={props.tab} provinces={props.provinces} />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </>
  );
};

export default ProportionalResult;
